<template>
  <div v-loading="loading">
    <div ref="tablePrint" class="print">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrint">
          <operatinglnxomeTable :collectionTabelTitel="collectionTabelTitel"
            :unCollectionAndHouse="unCollectionAndHouse" :handoverSalesTotal="handoverSalesTotal"
            :salesTabelTitel="salesTabelTitel" :statisticsData="statisticsData" :statisticsSum="statisticsSum"
            :sumsCollection="sumsCollection" :sumsSalesTotal="sumsSalesTotal" :listQuery="listQuery">
          </operatinglnxomeTable>
        </div>
      </div>
    </div>
    <div ref="tablePrintExport" class="Export_table" v-show="false">
      <div style="margin-top:10px;height:650px;overflow:auto">
        <div id="tablePrintExport">
          <operatinglnxomeTable :collectionTabelTitel="collectionTabelTitel"
            :unCollectionAndHouse="unCollectionAndHouse" :handoverSalesTotal="handoverSalesTotal"
            :salesTabelTitel="salesTabelTitel" :statisticsData="statisticsData" :statisticsSum="statisticsSum"
            :sumsCollection="sumsCollection" :sumsSalesTotal="sumsSalesTotal" :listQuery="listQuery" :exportShow='true'>
          </operatinglnxomeTable>
        </div>
      </div>
    </div>
    <div id="copy_div" v-show="false" style="'width:100%'" class="'flex-seting'"></div>
  </div>
</template>
<script>
  import DateUtils from '@/utils/DateUtils';
  import getLodop from '../../utils/Lodopfuncs'

  import operatinglnxomeTable from './operatinglnxomeTable'
  // import {
  //   operatingIncome
  // } from '@/api/reportcenter/ReportTableDefinition'
  // import getLodop from '@/utils/LodopFuncs.js'
  export default {
    components: {
      operatinglnxomeTable
    },
    data() {
      return {
        listQuery: {
          shiftCode: '',
          userId: '',
          outletId: '',
          startTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd "),
          endTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd "),
          queryLike: ''
        },
        employee: localStorage.getItem('user'),
        currentTime: DateUtils.formatDate(new Date(), "yyyy-MM-dd hh:mm"), //当前的时间
        hotelInfo: localStorage.getItem('hotelInfo'),
        loading: false,
        collectionTabelTitel: [],
        unCollectionAndHouse: [],
        handoverSalesTotal: [],
        salesTabelTitel: [],
        statisticsData: [],
        statisticsSum: {
          people_count: 0,
          avgPeoplePrice: 0,
          orderCount: 0,
          avgOrderPrice: 0,
          billCount: 0
        }
      }
    },
    created() {
      this.getInit()
      this.$bus.$on('todoQuery', this.getData)
      this.$bus.$on('todoPrintCatering', this.todoPrint)
      this.$bus.$on('todoExportCatering', this.todoExport)
    },
    beforeDestroy() {
      this.$bus.$off('todoQuery', this.getData);
      this.$bus.$off('todoPrintCatering', this.todoPrint)
      this.$bus.$off('todoExportCatering', this.todoExport)
    },
    computed: {
      sumsCollection: function () {
        let sums = []
        sums[this.collectionTabelTitel.length - 1] = undefined
        this.collectionTabelTitel.map((item, index) => {
          this.unCollectionAndHouse.map(sItem => {
            sItem[item.productCode] = sItem[item.productCode] ? sItem[item.productCode] : 0
            if (typeof (sItem[item.productCode]) == 'number') {
              if (!sums[index]) {
                sums[index] = 0
              }
              sums[index] += sItem[item.productCode] ? sItem[item.productCode] : 0
            }
          })
        })

        if (this.collectionTabelTitel.length) {
          sums[0] = '合计'
        }
        return sums
      },
      sumsSalesTotal: function () {
        let sums = []
        let arr = []
        // console.log(this.salesTabelTitel, this.handoverSalesTotal);
        let n = 0
        let m = 0
        sums[this.salesTabelTitel.length - 1] = undefined
        arr[this.salesTabelTitel.length - 1] = undefined
        this.salesTabelTitel.map((item, index) => {
          if (item.code == 'all_price') {
            n = index
          }
          if (item.code == 'peopleCount') {
            m = index
          }
          this.handoverSalesTotal.map(sItem => {

            sItem[item.code] = sItem[item.code] ? sItem[item.code] : 0
            if (typeof (sItem[item.code]) == 'number' && sItem['outletsName'].includes('小计')) {
              if (!sums[index]) {
                sums[index] = 0
              }
              sums[index] += sItem[item.code] ? sItem[item.code] : 0
            }

          })
        })

        if (this.salesTabelTitel.length) {
          sums[0] = '合计'
          if (sums[m] != 0) {
             sums[sums.length - 1] = sums[n] / sums[m]
          }else{
             sums[sums.length - 1]=0
          }
         
        }

        // console.log(sums);


        return sums
      }
    },
    methods: {
      getData(val) {
       
        this.listQuery = Object.assign({}, val)
        this.getInit()
      },
      getInit() {

        // 销售数据拼接


        var methods = "get"
        let url = this.api.operatingIncome
        let data = this.listQuery
        this.$axios({
          url,
          methods,
          data
        }).then(res => {
          if (res.data.status == 0) {
            this.salesTabelTitel = res.data.data && res.data.data.tabelTitel.length > 0 ? res.data.data.tabelTitel :
              []
            // 添加转房账和未接/挂账
            this.salesTabelTitel.push({
              code: 'server_price',
              chinese_desc: '服务费'
            })
            this.salesTabelTitel.push({
              code: 'tax',
              chinese_desc: '税率'
            })
            this.salesTabelTitel.push({
              code: 'all_price',
              chinese_desc: '合计'
            })
            this.salesTabelTitel.push({
              code: 'discount',
              chinese_desc: '折扣'
            })
            this.salesTabelTitel.push({
              code: 'peopleCount',
              chinese_desc: '人数'
            })
            this.salesTabelTitel.push({
              code: 'tableCount',
              chinese_desc: '餐桌数'
            })
            this.salesTabelTitel.push({
              code: 'avgPeoplePrice',
              chinese_desc: '人均消费'
            })

            // 在第一条插入营业点
            this.salesTabelTitel.unshift({
              code: 'shiftName',
              chinese_desc: '班次'
            })
            this.salesTabelTitel.unshift({
              code: 'outletsName',
              chinese_desc: '营业点'
            })

            let mapStatistics = new Map();

            this.handoverSalesTotal = res.data.data && res.data.data.operatingIncome.length > 0 ? res.data
              .data.operatingIncome : []

            let handoverSales = res.data.data && res.data.data.operatingIncomeHeader.length > 0 ? res.data.data
              .operatingIncomeHeader : []

            handoverSales.forEach(item => {
              if (mapStatistics.has(item.outletCode + item.shift_code)) {

                mapStatistics.get(item.outletCode + item.shift_code).push(item)
              } else {
                mapStatistics.set(item.outletCode + item.shift_code, [item])
              }
            })
            mapStatistics.forEach(item => {
              let left = 0
              this.handoverSalesTotal.forEach((v, i) => {
                if (v.outletsCode + v.shift_code == item[0].outletCode + item[0].shift_code) {
                  item.forEach(sub => {
                    v[sub.code] = sub.total_price
                  })
                }
              })
            })
            if (this.handoverSalesTotal.length) {

              let arr = this.handoverSalesTotal
              let left = 0;
              let obj = {}
              for (let i in arr[left]) {
                // console.log(i);
                if (i == 'outletsName') {

                  obj.outletsName = arr[left].outletsName + '小计'

                } else if (i == 'shiftName') {
                  obj.shiftName = '小计'
                } else {
                  obj[i] = arr[left][i]
                }
              }

              for (let right = 1; right <= arr.length; right++) {


                if (right == arr.length - 1) {

                  Object.keys(obj).forEach(mm => {

                    if (obj[mm]) {
                      if (typeof (obj[mm]) == 'number') {
                        obj[mm] = 0
                      }
                    }
                  })
                  obj.outletsName = arr[left].outletsName + '小计'
                  let num = right + 1 - left

                  for (let n = 0; n < num; n++) {
                    for (let m in obj) {
                      if (typeof (obj[m]) == 'number') {
                        for (let index in arr[left + n]) {
                          if (m == index) {
                            obj[m] += arr[left + n][index] > 0 ? arr[left + n][index] : 0
                          }

                        }
                      }
                    }
                  }

                  let objs = JSON.parse(JSON.stringify(obj))
                  if (objs['peopleCount'] == 0) {
                    objs['avgPeoplePrice'] = 0

                  } else {
                    objs['avgPeoplePrice'] = objs['all_price'] / objs['peopleCount']

                  }
                  arr.splice(right + 1, 0, objs)
                  return
                }

                if (arr[left].outletsCode != arr[right].outletsCode) {
                  // console.log(obj);
                  Object.keys(obj).forEach(mm => {

                    if (obj[mm]) {
                      if (typeof (obj[mm]) == 'number') {
                        obj[mm] = 0
                      }
                    }
                  })
                  obj.outletsName = arr[left].outletsName + '小计'
                  let num = right - left
                  // console.log(1111, num, obj);
                  for (let n = 0; n < num; n++) {

                    for (let m in obj) {
                      // console.log(m);
                      if (typeof (obj[m]) == 'number') {
                        for (let index in arr[left + n]) {
                          if (m == 'all_price') {
                            // console.log(obj[m], arr[left + n][index]);
                          }
                          if (m == index) {


                            obj[m] += arr[left + n][index] > 0 ? arr[left + n][index] : 0
                          }

                        }
                      }
                    }
                  }

                  let objs = JSON.parse(JSON.stringify(obj))
                  if (objs['peopleCount'] == 0) {
                    objs['avgPeoplePrice'] = 0

                  } else {
                    objs['avgPeoplePrice'] = objs['all_price'] / objs['peopleCount']

                  }
                  arr.splice(right, 0, objs)
                  if (right < arr.length) {
                    left = right + 1
                  }



                }

              }
              // console.log(3445, arr, left, right, arr.length);
            }

          }
        })
      },
      todoPrint(type) {
        const LODOP = getLodop()
        // 获取大小和宽度
        let printSize = 12
        let width = 2
        if (LODOP) {
          // 判断是否是数字
          let falg = false
          if (document.getElementById('tablePrint')) {
            document.getElementById("copy_div").innerHTML = ""
            let innerHTML = document.getElementById('tablePrint').cloneNode(true)
            innerHTML.style.border = 'none'
            innerHTML.style.borderCollapse = 'collapse'
            innerHTML.style.fontSize = printSize + 'px'
            document.getElementById("copy_div").appendChild(innerHTML);
            falg = true
          }
          this.$nextTick(() => {
            var strFormHtml = `
                <body >` +
              document.getElementById(falg ? 'copy_div' : 'tablePrint').innerHTML +
              '</body>' //获取打印内容
            LODOP.PRINT_INIT('') //初始化
            LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') //设置纵向
            LODOP.ADD_PRINT_HTM('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
            LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
            LODOP.SET_PRINT_STYLEA(0, "LetterSpacing", 0)
            LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, '') //设置预览窗口模式和大小
            if (type === 'preview') {
              LODOP.PREVIEW();
            } else {
              LODOP.PRINT()
            }
          })
        }
      },
      todoExport() {
        const LODOP = getLodop()
        if (LODOP) {
          // 获取大小和宽度
          let width = 2
          var strFormHtml = '<body>' + document.getElementById('tablePrintExport').innerHTML + '</body>' //获取打印内容
          LODOP.PRINT_INIT('') //初始化
          LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4') //设置纵向
          LODOP.ADD_PRINT_TABLE('2%', width + '%', (100 - width * 2) + '%', '88%', strFormHtml)
          LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -100)
          LODOP.SAVE_TO_FILE("餐饮收入情况统计日报.xlsx");
        }
      }
    }
  }
</script>